import { RotateCcwIcon } from 'lucide-preact';

import { cn } from '@/lib/utils';

export interface GuidedTourButton {
  label: string;
  onClick?: () => void;
}

interface GuidedTourBannerProps {
  message?: string;
  mascotSrc: string;
  buttons?: GuidedTourButton[];
  onGoBack?: () => void;
  onTakeABreak?: () => void;
  className?: string;
}

const GuidedTourBanner = ({
  message,
  mascotSrc,
  buttons = [],
  onGoBack,
  onTakeABreak,
  className,
}: GuidedTourBannerProps) => {
  return (
    <div className={cn('preflight relative h-[139px] shrink-0 grow-0 overflow-hidden bg-[#FFDF6C]', className)}>
      <img
        src={mascotSrc}
        alt="Zoolife mascot"
        className="preflight absolute left-[9px] top-[-1px] h-[140px] w-[127px] object-contain"
      />

      <div className="preflight flex h-full">
        <div className="preflight w-[147px] shrink-0" />

        <div className="preflight flex min-w-0 flex-1 flex-col pt-[15px]">
          {message && (
            <div className="preflight relative ml-[10px] min-h-[71px] max-w-[889px] rounded-[10px] bg-white px-[15px] pb-4 pt-3">
              <div className="preflight absolute left-[-13px] top-[19px] h-0 w-0 border-y-[10px] border-r-[13px] border-y-transparent border-r-white" />
              <p className="preflight preflight-p text-lg font-bold leading-[1.2] text-[#1c1917]">{message}</p>
            </div>
          )}

          {buttons.length > 0 && (
            <div className={cn('preflight flex gap-4', message ? 'mt-2' : 'ml-[10px] mt-[15px]')}>
              {buttons.map((btn) => (
                <button
                  key={btn.label}
                  type="button"
                  onClick={btn.onClick}
                  className="preflight preflight-button flex h-8 items-center justify-center whitespace-nowrap rounded-full bg-primary-green px-4 py-2 text-base font-bold leading-none text-white"
                >
                  {btn.label}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="preflight flex shrink-0 flex-col items-end gap-8 pr-[14px] pt-[18px]">
          {onGoBack && (
            <button
              type="button"
              onClick={onGoBack}
              className="preflight preflight-button flex items-center gap-[5px] text-xs font-bold leading-normal text-primary-green"
            >
              <RotateCcwIcon className="h-6 w-6 text-primary-green" />
              Go Back a Step
            </button>
          )}
          {onTakeABreak && (
            <button
              type="button"
              onClick={onTakeABreak}
              className="preflight preflight-button flex h-[47px] items-center justify-center whitespace-nowrap rounded-full bg-[#458254] px-5 py-[3px] text-lg font-bold text-white"
            >
              Explore On My Own
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GuidedTourBanner;
